import {
    BOOK_WITH_ME_PATH_NAME,
    ATTENDEE_PAGE_KEYWORD,
} from '../store/schema/BookWithMeRouteConstants';
import getObscuredCurrentUserAddress from '../utils/getObscuredCurrentUserAddress';
import { isMsalEnabledForBusiness } from 'owa-msaljs/lib/isMsalEnabledForBusiness';
import { getApplicationSettings } from 'owa-application-settings';
import { isFeatureEnabled } from 'owa-feature-flags';

const DEFAULT_DOMAIN = 'outlook.office.com';

/**
 * Util to get published URL of the booking page from store.
 */

const getDomainURL = () => {
    if (isFeatureEnabled('bookings-fixBookingCustomDomain')) {
        const domainURL = new URL(getApplicationSettings('BookingsDomainConfig').domainURL);
        return domainURL.hostname;
    } else {
        const currentDomain = `${window.location.hostname}` || DEFAULT_DOMAIN;
        return currentDomain;
    }
};

export default function getBookWithMePublishedUrl(): string {
    const currentPath = getDomainURL();
    const pathName =
        BOOK_WITH_ME_PATH_NAME +
        '/' +
        ATTENDEE_PAGE_KEYWORD +
        '/' +
        getObscuredCurrentUserAddress() +
        '?anonymous';
    // TDS box requires a link based in host: https://exchangelabs.live-int.com:444/findtime/..., prod keeps using outlook.office.com host.
    // DOD/GCCH also have different hostnames

    // Temporary change done to support MSAL migration changes
    const newUrlLink = isMsalEnabledForBusiness()
        ? `https://${currentPath}/${pathName}&ismsaljsauthenabled`
        : `https://${currentPath}/${pathName}`;

    return newUrlLink;
}
